try {
    const braintree_client_token = document.head.querySelector('meta[name="braintree-client-authorization"]');

    window.authorization = braintree_client_token.content;
} catch (e) {
    console.error('Unable to load braintree module' + e);
} finally {
    const paymentCheckoutForm = document.getElementById('payment-checkout-form'),
        paymentButton = document.getElementsByClassName('pay-button'),
        emailForm = document.getElementById('setupEmailForm');

    if(typeof emailForm !== 'undefined' && emailForm !== null){
        addEvent(emailForm, "submit", function (e) {
            e.preventDefault();
            let emailInput = document.createElement("input");
            emailInput.type = "hidden";
            emailInput.name = "email";
            emailInput.value = emailForm.getElementsByTagName('input')[0].value;
            // emailInput.type ="hidden";
            paymentCheckoutForm.appendChild(emailInput);
            document.getElementsByClassName('setupEmail')[0].style.display = "none";
            document.getElementsByClassName('paymentForm')[0].style.display = "block";
        });
    }

    let dropinInstance = dropin.create({
        authorization: authorization,
        container: '#payment-container',
        threeDSecure: {
            amount: jQuery('input[name="plan"]').attr('data-price')
        },
        card: {
            cardholderName: true
        },
        paypal: {
            flow: 'vault',
            buttonStyle: {
                layout: 'horizontal',  // horizontal | vertical
                size: 'responsive',    // medium | large | responsive
                shape: 'pill',      // pill | rect
                color: 'gold'       // gold | blue | silver | black
            }
        },
    }, function (createErr, instance) {

        const chooseAnotherPaymentMethodToggle = document.querySelector('div[data-braintree-id="toggle"]').firstElementChild;


        addEvent(chooseAnotherPaymentMethodToggle, "click", function () {
            console.log('clicked');
            instance.clearSelectedPaymentMethod();
            toggleStateToUpgradeButton();
        });
        addEvent(paymentCheckoutForm, "submit", function (e) {
            e.preventDefault();
        });

        if (createErr) {
            // An error in the create call is likely due to
            // incorrect configuration values or network issues.
            // An appropriate error will be shown in the UI.

            addPaymentErrorMessage(createErr);
            return;
        }

        function sendNonceToServer() {
            instance.requestPaymentMethod(function (requestPaymentMethodErr, payload) {
                if (requestPaymentMethodErr) {
                    //console.log('eerrors');
                    // No payment method is available.
                    // An appropriate error will be shown in the UI.
                    addEvent(paymentCheckoutForm, "submit", function (e) {
                        e.preventDefault();
                    });
                    return;
                }

                let liabilityShifted = payload.liabilityShifted,
                    liabilityShiftPossible = payload.liabilityShiftPossible;
                addPaymentErrorMessage();
                addHiddenPaymentInput('authorization', payload.nonce);
                addHiddenPaymentInput('payment-type', payload.type);
                addHiddenPaymentInput('details', JSON.stringify(payload.details));
                if (payload.deviceData) {
                    addHiddenPaymentInput('device-data', JSON.stringify(payload.details));
                }
                if (liabilityShiftPossible && !liabilityShifted) {
                    instance._removeUnvaultedPaymentMethods();
                    addPaymentErrorMessage("3D Secure could not validate this transaction. Try another payment method!");
                    return '';
                } else {
                    addPaymentErrorMessage();
                }

                //console.info('added the form data');
                closePaymentForm();
                paymentCheckoutForm.submit();

                // send payload.nonce to your server
            });
        }

        instance.on('paymentMethodRequestable', function (event) {
            // if the nonce is already available (via PayPal authentication
            // or by using a stored payment method), we can request the
            // nonce right away. Otherwise, we wait for the customer to
            // request the nonce by pressing the submit button once they
            // are finished entering their credit card details
            toggleStateToUpgradeButton(true);
        });

        if (instance.isPaymentMethodRequestable()) {
            // This will be true if you generated the client token
            // with a customer ID and there is a saved payment method
            // available to tokenize with that customer.
            // sendNonceToServer();
            //console.info('is paymentMethodRequestable');

            instance.clearSelectedPaymentMethod();
        }


        instance.on('paymentOptionSelected', function (payload) {
            //console.log('paymentOptionSelected');
            //console.log(payload.paymentOption);
            if (payload.paymentOption == 'paypal') {
                toggleStateToUpgradeButton();
            } else {
                toggleStateToUpgradeButton(true);
            }
        });


        instance.on('noPaymentMethodRequestable', function () {
            //console.log('noPaymentMethodRequestable');
            // toggleStateToUpgradeButton();
        });
        instance.on('changeActivePaymentView', function () {
            //console.log('changeActivePaymentView');
            toggleStateToUpgradeButton();
        });
        addEvent(paymentButton[0], "click", function () {
            //console.log('add event on button');
            instance.updateConfiguration('threeDSecure', 'amount', jQuery('input[name="plan"]').attr('data-price'));
            sendNonceToServer();
        });
        //do something special


    });


    function closePaymentForm() {
        const pageIsLoading = document.createAttribute("class");
        pageIsLoading.value = "pageIsLoading";
        document.getElementsByTagName("body")[0].setAttributeNode(pageIsLoading);
        toggleStateToUpgradeButton();
        addPaymentErrorMessage();
    }

    function toggleStateToUpgradeButton(enable = null) {
        if (enable) {
            paymentButton[0].disabled = false;
            paymentButton[0].style.display = 'block';

        } else {
            paymentButton[0].disabled = true;
            paymentButton[0].style.display = 'none';
        }
        addPaymentErrorMessage();
    }

    function addPaymentErrorMessage($message = undefined) {

        const divError = document.createElement('div'),
            errorParagraph = document.createElement('p'),
            textNode = document.createTextNode($message);

        if (document.getElementsByClassName('error-payment-message').length > 0) {
            document.getElementsByClassName('error-payment-message').remove();
        }
        if ($message !== undefined) {
            divError.setAttribute('class', 'error-payment-message');
            errorParagraph.appendChild(textNode);
            divError.appendChild(errorParagraph);
            divError.style = 'color: red; text-align: center;';
            divError.appendBefore(document.querySelector('div[data-braintree-id="upper-container"]'))
        }
    }

    function addHiddenPaymentInput($name, $data) {
        const hiddenInput = document.createElement('input');
        if (document.getElementsByName($name).length > 0) {
            document.getElementsByName($name).remove();
        }
        hiddenInput.setAttribute('type', 'hidden');
        hiddenInput.setAttribute('name', $name);
        hiddenInput.setAttribute('value', $data);
        paymentCheckoutForm.appendChild(hiddenInput);
    }

    //add event listener
    function addEvent(element, eventName, callback) {
        if (element.addEventListener) {
            element.addEventListener(eventName, callback, false);
        } else if (element.attachEvent) {
            element.attachEvent("on" + eventName, callback);
        }
    }
}
